import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from '../selectors/auth.selectors';
import { Login } from './Login';

export const Authenticator: React.FC<PropsWithChildren> = ({ children }) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  if (!isLoggedIn) {
    return <Login />;
  }

  return <>{children}</>;
};
